import { useEffect } from 'react';
import { useLightboxStore } from '@store/uiStore';

export function ImageLightbox() {
  const { imageUrl, alt, closeLightbox } = useLightboxStore();

  useEffect(() => {
    if (!imageUrl) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeLightbox();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [imageUrl, closeLightbox]);

  if (!imageUrl) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 p-4">
      <button
        type="button"
        aria-label="Kapat"
        className="absolute inset-0"
        onClick={closeLightbox}
      />
      <button
        type="button"
        onClick={closeLightbox}
        className="absolute right-4 top-4 z-10 rounded-full bg-white/20 p-2 text-2xl text-white hover:bg-white/30"
      >
        ✕
      </button>
      <img
        src={imageUrl}
        alt={alt}
        className="relative z-[1] max-h-[90vh] max-w-full rounded-lg object-contain"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
